import React from 'react';
import { CheckCircle2, Clock, FileText, ShieldCheck } from 'lucide-react';

const eligibilityRows = [
  { label: 'Current file status', state: 'Verified File — Active', icon: ShieldCheck },
  { label: 'Days live on Tangibl3Net', state: '42 / 90', icon: Clock },
  { label: 'Days remaining until eligibility', state: '48', icon: Clock },
  { label: 'Compliance exceptions', state: '0', icon: CheckCircle2 },
  { label: 'Marketing violations', state: '0', icon: CheckCircle2 },
  { label: 'Document completeness', state: 'Yes', icon: FileText },
  { label: 'Business Development eligibility', state: 'Not Yet Eligible', icon: ShieldCheck },
  { label: 'Contest eligibility', state: 'Not Yet Eligible', icon: ShieldCheck },
];

const IssuerFileStatus = () => (
  <section id="program-eligibility" className="py-24 lg:py-32 bg-muted/20 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="text-center mb-14">
        <div className="section-label mb-4">Program Eligibility</div>
        <h2 className="font-display text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
          Example file status before business development or contest eligibility.
        </h2>
        <p className="mt-5 max-w-2xl mx-auto text-lg text-muted-foreground leading-relaxed">
          Projects can apply immediately, but business development and contest eligibility require at least 90 days live on Tangibl3Net with Verified File — Active status and no unresolved critical issues.
        </p>
        <p className="mt-4 max-w-2xl mx-auto text-sm text-muted-foreground leading-relaxed">
          Illustrative example — the values below are sample data, not a real issuer file. This page has no live backend; nothing here is tracked live.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {eligibilityRows.map((item) => (
          <div key={item.label} className="rounded-2xl border border-border bg-card p-6">
            <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
              <item.icon className="w-5 h-5 text-primary" />
            </div>
            <h3 className="font-display text-lg font-bold text-foreground">{item.label}</h3>
            <div className="mt-3 inline-flex rounded-md bg-muted px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
              {item.state}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default IssuerFileStatus;
